export default __webpack_public_path__ + "static/media/nitro-analytics.3d45fb9d.png";